import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, Dialog, Divider, FormControlLabel, IconButton, Radio, RadioGroup, Stack, Typography, } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import Slider from '../../../../Slider';
import { CloseCircleOutline, ContentCopy } from 'mdi-material-ui';
import { useState } from 'react';
const displayLabel = {
    marketFactors: [
        {
            key: 'brandStage',
            displayName: 'Brand Stage',
            name: 'campaignDetails.expectedFrequency.marketFactors.brandStage',
            marks: [
                { value: 1, label: 'Established Brand' },
                { value: 5, label: 'New Brand' },
            ],
            ex1: 'Coke',
            ex2: 'ABC foods',
        },
        {
            key: 'marketShare',
            displayName: 'Market Share',
            name: 'campaignDetails.expectedFrequency.marketFactors.marketShare',
            marks: [
                { value: 1, label: 'High Market Share' },
                { value: 5, label: 'Low Market Share' },
            ],
            ex1: 'Maruti',
            ex2: 'MG Hector',
        },
        {
            key: 'purchaseCycle',
            displayName: 'Purchase Cycle',
            name: 'campaignDetails.expectedFrequency.marketFactors.purchaseCycle',
            marks: [
                { value: 1, label: 'Long Purchase Cycle' },
                { value: 5, label: 'Short Purchase Cycle' },
            ],
            ex1: 'SBI Home Loan',
            ex2: 'Tata Salt',
        },
        // {
        //   key: 'usageFreq',
        //   displayName: 'Usage Freq',
        //   name: 'campaignDetails.expectedFrequency.marketFactors.usageFreq',
        //   marks: [
        //     { value: 1, label: 'Less Frequent Usage' },
        //     { value: 5, label: 'Frequent Usage' },
        //   ],
        //   ex1: 'Makemytrip Holiday',
        //   ex2: 'Samsung Mobile',
        // },
        {
            key: 'sov',
            displayName: 'SOV',
            name: 'campaignDetails.expectedFrequency.marketFactors.sov',
            marks: [
                { value: 1, label: 'High Share of Voice' },
                { value: 5, label: 'Low Share of Voice' },
            ],
            ex1: 'Dream11',
            ex2: 'Zerodha',
        },
    ],
    adFactors: [
        {
            key: 'messageComplexity',
            displayName: 'Message Complexity',
            name: 'campaignDetails.expectedFrequency.adFactors.messageComplexity',
            marks: [
                { value: 1, label: 'Low message complexity' },
                { value: 5, label: 'High message complexity' },
            ],
            ex1: 'Surf Excel',
            ex2: 'Cred',
        },
        {
            key: 'messageUniqueness',
            displayName: 'Message Uniqueness',
            name: 'campaignDetails.expectedFrequency.adFactors.messageUniqueness',
            marks: [
                { value: 1, label: 'High Message Uniqueness' },
                { value: 5, label: 'Low Message Uniqueness' },
            ],
            ex1: 'Fevicol',
            ex2: 'Rummy123',
        },
        {
            key: 'campaignStage',
            displayName: 'Campaign Stage',
            name: 'campaignDetails.expectedFrequency.adFactors.campaignStage',
            marks: [
                { value: 1, label: 'Existing Campaign' },
                { value: 5, label: 'New Campaign' },
            ],
            label1: 'Existing Campaign',
            label2: 'New Campaign',
        },
    ],
    mediaFactors: [
        {
            key: 'seasonality',
            displayName: 'Seasonality',
            name: 'campaignDetails.expectedFrequency.mediaFactors.seasonality',
            marks: [
                { value: 1, label: 'Low Season' },
                { value: 5, label: 'High Season' },
            ],
            ex1: 'Tata Salt',
            ex2: 'LG Air Conditioner',
        },
        {
            key: 'duration',
            displayName: 'Duration',
            name: 'campaignDetails.expectedFrequency.mediaFactors.duration',
            marks: [
                { value: 1, label: 'Long Campaign Duration' },
                { value: 5, label: 'Short Campaign Duration' },
            ],
        },
        {
            key: 'schedulingType',
            displayName: 'Scheduling Type',
            name: 'campaignDetails.expectedFrequency.mediaFactors.schedulingType',
            marks: [
                { value: 1, label: 'Continuous Scheduling' },
                { value: 5, label: 'Flighting' },
            ],
        },
        {
            key: 'mediaChannels',
            displayName: 'Media Channels',
            name: 'campaignDetails.expectedFrequency.mediaFactors.mediaChannels',
            marks: [
                { value: 1, label: 'Multiple Media Channels' },
                { value: 5, label: 'Single Media' },
            ],
        },
    ],
    // objective: [
    //   {
    //     key: 'markObjective',
    //     displayName: 'Marketing Objective',
    //     name: 'campaignDetails.expectedFrequency.objective.markObjective',
    //     marks: [
    //       { value: 1, label: 'Awareness' },
    //       { value: 5, label: 'Trial' },
    //     ],
    //   },
    // ],
};
const FrequencyEstimator = ({ setEstimatedFrequency, }) => {
    const { getValues } = useFormContext();
    const frequencyEstimator = getValues('campaignDetails.expectedFrequency');
    const [open, setOpen] = useState(false);
    const InputTitle = ({ name, color, }) => (_jsx(Typography, Object.assign({ variant: "h4", color: color }, { children: name })));
    const getSetData = (key, type) => {
        switch (key) {
            case 'marketFactors':
                return type === 'name' ? 'Market Factors' : 0.46;
            case 'adFactors':
                return type === 'name' ? 'Ad Factors' : 0.27;
            case 'mediaFactors':
                return type === 'name' ? 'Media Factors' : 0.27;
            case 'objective':
                return type === 'name' ? 'Objective' : 1;
        }
    };
    const calculateSetAverage = (key) => {
        let sum = 0;
        for (let item in frequencyEstimator[key])
            sum += frequencyEstimator[key][item];
        return (sum / Object.keys(frequencyEstimator[key]).length).toFixed(2);
    };
    const calculateEstimatedFrequency = () => {
        let tempFrequency = 0;
        Object.keys(frequencyEstimator).forEach((set) => {
            if (set !== 'objective') {
                let sum = 0;
                for (let item in frequencyEstimator[set])
                    sum += frequencyEstimator[set][item];
                let weight = getSetData(set, '');
                tempFrequency +=
                    (sum / Object.keys(frequencyEstimator[set]).length - 2.5) * weight;
            }
        });
        return (frequencyEstimator['objective']['markObjective'] +
            Math.round(tempFrequency));
    };
    const onSubmit = () => {
        setOpen(false);
        setEstimatedFrequency(calculateEstimatedFrequency());
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ variant: "outlined", startIcon: _jsx(ContentCopy, {}), sx: {
                    borderRadius: '0px',
                    marginLeft: '-1px',
                    '&.MuiButtonBase-root': {
                        borderTopLeftRadius: '0px',
                        borderBottomLeftRadius: '0px',
                        borderTopRightRadius: '4px',
                        borderBottomRightRadius: '4px',
                    },
                }, onClick: () => setOpen(true) }, { children: "Calculate Frequency" })), _jsxs(Dialog, Object.assign({ open: open, onClose: () => setOpen(false), PaperProps: { sx: { width: '640px', maxHeight: '80%', p: 4 } } }, { children: [_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", justifyContent: "space-between" }, { children: [_jsx(Typography, Object.assign({ variant: "h1" }, { children: "Frequency Estimator" })), _jsx(IconButton, Object.assign({ onClick: () => setOpen(false) }, { children: _jsx(CloseCircleOutline, {}) }))] })), _jsxs(Box, Object.assign({ sx: { overflow: 'auto', height: '80%' } }, { children: [Object.keys(displayLabel).map((item, index) => (_jsxs(Box, Object.assign({ m: '10px 0px' }, { children: [_jsx(Typography, Object.assign({ color: "text.dark", variant: "h2", sx: { backgroundColor: '#e0e0e0' } }, { children: getSetData(item, 'name') })), _jsx(Stack, Object.assign({ alignItems: "center" }, { children: displayLabel[item].map((sliderKey) => (_jsxs(Box, Object.assign({ sx: { width: '90%', margin: '10px 0px' } }, { children: [_jsx(InputTitle, { name: sliderKey.displayName, color: "text.dark" }), _jsx(Controller, { name: sliderKey.name, render: ({ field }) => (_jsx(Slider, Object.assign({}, field, { value: field.value, "aria-labelledby": "range-slider", min: 1, max: 5, step: 1, sx: { marginLeft: '10%' }, marks: sliderKey.marks, valueLabelDisplay: "on", valueLabelFormat: (value) => value }))) }), sliderKey.ex1 && (_jsxs(Stack, Object.assign({ justifyContent: "space-between", direction: "row" }, { children: [_jsxs(Stack, Object.assign({ direction: "row" }, { children: [_jsx(InputTitle, { name: "Ex.1: ", color: "text.dark" }), _jsx(InputTitle, { name: sliderKey.ex1, color: "text.dark" })] })), _jsxs(Stack, Object.assign({ direction: "row" }, { children: [_jsx(InputTitle, { name: "Ex.2: ", color: "text.dark" }), _jsx(InputTitle, { name: sliderKey.ex2, color: "text.dark" })] }))] }))), _jsx(Divider, { sx: { marginTop: '10px' } })] }), sliderKey.key))) })), _jsxs(Typography, Object.assign({ variant: "h2" }, { children: ["Average : ", calculateSetAverage(item)] }))] }), index))), _jsx(Controller, { name: "campaignDetails.expectedFrequency.objective.markObjective", render: ({ field }) => (_jsxs(_Fragment, { children: [_jsx(Typography, Object.assign({ color: "text.dark", variant: "h2", sx: { backgroundColor: '#e0e0e0', m: '10px 0px' } }, { children: "Objective Mark - Objective" })), _jsxs(RadioGroup, Object.assign({ row: true, value: field.value, onChange: (e) => field.onChange((field.value = +e.target.value)), sx: { m: '10px 30px' } }, { children: [_jsx(FormControlLabel, { value: 3, control: _jsx(Radio, {}), label: "Awareness" }), _jsx(FormControlLabel, { value: 4, control: _jsx(Radio, {}), label: "Consideration" }), _jsx(FormControlLabel, { value: 5, control: _jsx(Radio, {}), label: "Trial" })] })), _jsxs(Typography, Object.assign({ variant: "h2" }, { children: ["Average : ", calculateSetAverage('objective')] }))] })) })] })), _jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", justifyContent: "space-between" }, { children: [_jsxs(Typography, { children: ["Estimated Frequency : ", calculateEstimatedFrequency()] }), _jsx(Button, Object.assign({ variant: "contained", size: "small", sx: { margin: '10px 30px', float: 'right' }, onClick: onSubmit }, { children: "Submit" }))] }))] }))] }));
};
export default FrequencyEstimator;
